/**
 * Lenis Smooth Scroll Initialization
 *
 * Loaded as `type="module"` from `snippets/scripts.liquid`. A classic script
 * puts top-level `const initLenis` in the shared global lexical environment,
 * so a second evaluation throws (Sentry SHOPIFY-THEME-FA / #766). Modules
 * get their own scope, and the same module URL is not executed twice.
 */
const initLenis = () => {
  // @ts-ignore
  if (typeof Lenis === "undefined") {
    console.warn("Lenis library not loaded");
    return;
  }
  // @ts-ignore
  const lenis = new Lenis({
    autoRaf: true,
    duration: 0.8,
    smoothWheel: true,
    smoothTouch: false,
  });
  window.__mysaLenis = lenis;
  // @ts-ignore
  // lenis.on("scroll", (e) => {
  //   // @ts-ignore
  //   if (Shopify.previewMode) {
  //     console.log(e);
  //   }
  // });

  // Programmatic scroll — see MysaEvents.scrollTo in assets/mysa-events.js.
  // When a dialog has stopped Lenis, ignore scroll requests so the page never
  // moves behind an open modal/drawer. Callers that must move the page while a
  // dialog is open should close it first. (Lenis also no-ops scrollTo when
  // stopped unless `force: true`; the explicit guard keeps that contract local.)
  document.addEventListener("mysa:scroll-to", (event) => {
    const detail =
      /** @type {CustomEvent<{ top?: number; immediate?: boolean }>} */ (event)
        .detail;
    if (typeof detail?.top !== "number") return;
    if (lenis.isStopped) return;
    lenis.scrollTo(detail.top, { immediate: detail.immediate ?? false });
  });

  // Dialog open/close can nest (e.g. mysa-modal + dialog-component).
  // Reference-count so Lenis stays stopped until the last sheet closes, and
  // resync animatedScroll to the restored window.scrollY before start() —
  // DialogComponent locks the body (scrollY → 0) on open and restores with
  // native scrollTo on close; starting without a sync snaps/fights the page.
  let openDialogCount = 0;

  document.addEventListener("dialog:open", () => {
    openDialogCount += 1;
    if (openDialogCount === 1) {
      lenis.stop();
    }
  });

  document.addEventListener("dialog:close", () => {
    openDialogCount = Math.max(0, openDialogCount - 1);
    if (openDialogCount > 0) return;

    // Wait a frame so DialogComponent can unlock the body and native
    // scrollTo can apply. Reading window.scrollY synchronously is 0 while
    // the lock is still in place (or while smooth-scroll has not moved).
    requestAnimationFrame(() => {
      lenis.scrollTo(window.scrollY, { immediate: true, force: true });
      lenis.start();
    });
  });
};

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLenis);
} else {
  initLenis();
}
